import { defineStore } from "pinia";

export const useLocationStore = defineStore('location', {
    state: () => {
      return {
        locations: [{ value: 0, label: { en: 'all Locations' } }]
      }
    },
    persist: true,
});